import { LogLevel, OpenIdConfiguration } from 'angular-auth-oidc-client';
import { Stage } from '../enums';

export const environment = {
    stage: Stage.DEV,
    production: true,
    apiUrl: `https://api.${
        window.location.origin.includes('qa') ? 'qa' : 'dev' // Remove once fully migrated to shs environment
    }.my-digital-lab-assistant.siemens-healthineers.com/v1`,
    authentication: {
        unauthorizedRoute: '/auth/unauthorized',
        redirectUrl: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
        clientId: 'o8u4EtJXJ3YRlQJW2x7QhBV36Re6gpWw',
        authority: 'https://shs.login-qa.siemens-healthineers.com/',
        authWellknownEndpointUrl: 'https://shs.login-qa.siemens-healthineers.com/.well-known/openid-configuration',
        scope: 'openid profile email offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        autoUserInfo: false,
        renewTimeBeforeTokenExpiresInSeconds: 300,
        maxIdTokenIatOffsetAllowedInSeconds: 600,
        renewUserInfoAfterTokenRenew: true,
        ignoreNonceAfterRefresh: true,
        authWellknownEndpoints: {
            userInfoEndpoint: 'https://shs-qa-001-001.eu.auth0.com/userinfo',
            authorizationEndpoint: 'https://shs.login-qa.siemens-healthineers.com/authorize',
            tokenEndpoint: 'https://shs.login-qa.siemens-healthineers.com/oauth/token',
            jwksUri: 'https://shs.login-qa.siemens-healthineers.com/.well-known/jwks.json',
            revocationEndpoint: 'https://shs.login-qa.siemens-healthineers.com/oauth/revoke',
            issuer: 'https://shs.login-qa.siemens-healthineers.com/'
        },
        historyCleanupOff: false,
        logLevel: LogLevel.Debug
    } as OpenIdConfiguration,
    awsAppSync: {
        graphqlEndpoint: 'https://ws.dev.my-digital-lab-assistant.siemens-healthineers.com/graphql'
    },
    iroUrl: 'https://dev.iro.my-digital-lab-assistant.siemens-healthineers.com/',
    // Base URL for the CloudFront-hosted i18n translation files. Empty falls back
    // to the bundled `/assets/i18n/` folder until the distribution is available.
    i18nBaseUrl: ''
};
